import { Stack } from '@chakra-ui/react';
import Search from '@/components/search/Search';

export default function SearchTool() {
  return (
    <Stack
      flexDirection={'column'}
      justifyContent={'flex-start'}
      height={'fit-content'}
      width={'100%'}
      padding={4}
    >
      <Search />
    </Stack>
  );
}
